import type { CommonConditionsState } from "../../../../types/states";

type CommonConditionsItem = CommonConditionsState["checkboxData"][number];
type Input = CommonConditionsItem;
type Output = CommonConditionsItem;
type ToggleCategoryItemChecked = (
  checkboxId: string
) => (input: Input) => Output;

export const getToggleCategoryItemChecked: ToggleCategoryItemChecked =
  (checkboxId) => (input) => {
    if (input.checkboxId !== checkboxId) return input;

    return {
      ...input,
      isChecked: !input.isChecked,
    };
  };
